// extracted by mini-css-extract-plugin
export default {"NabForMarriegeItem":"NabForMarriegeItem_NabForMarriegeItem__QGaG0"};